import {bindable, containerless, customElement, inject} from "aurelia-framework";
import {parsePhoneNumberFromString, isValidPhoneNumber, getCountries, getCountryCallingCode} from "libphonenumber-js";
import {UserClient} from "../api/user-client";

const START = 0x1F1E6 /* REGIONAL INDICATOR SYMBOL LETTER A */ - 0x41 /* LATIN CAPITAL LETTER A */;

@inject(UserClient)
@containerless() @customElement("phone-display")
export class PhoneDisplay {

    @bindable value;
    @bindable numberValid = "";

    customPrefixes = {
        '90': '🪖',
    };

    constructor(user) {
        this.user = user;
    }
    
    bind() {
        this.country = null;
        this.number = this.value;
        if (this.value) {
            this.tel = 'tel:' + this.value?.replaceAll('-', '');
        }

        const userCountry = this.user.getCountry();

        const customCode = Object.keys(this.customPrefixes).find(
            prefix => this.value?.startsWith(prefix)
        );
        if (customCode) {
            this.country = customCode;
            this.number = this.value;
            this.emoji = this.customPrefixes[customCode];
            return;
        }

        try {
            const parsed = parsePhoneNumberFromString(this.value, userCountry);
            let phoneCountry = parsed && parsed.country;

            let countries = {};

            for (let country of getCountries()) {
                let cc = getCountryCallingCode(country);

                if (!countries[cc]) {
                    countries[cc] = [];
                }

                countries[cc].push(country);
            }

            if (!phoneCountry && countries?.[parsed.countryCallingCode]?.[0]) {
                phoneCountry = countries?.[parsed.countryCallingCode]?.[0];
            }

            if (!isValidPhoneNumber(parsed.number, phoneCountry)) {
                this.numberValid = "(ungültige Rufnummer)";
            }

            if (!phoneCountry) {
                return;
            }

            if (this.user.getUser().settings?.userSettings?.showLocalNumber && phoneCountry === userCountry) {
                this.number = parsed.formatNational();
            } else {
                this.country = phoneCountry;
                this.emoji = String.fromCodePoint(START + phoneCountry.charCodeAt(0), START + phoneCountry.charCodeAt(1));
            }

        } catch (e) {
            console.error(e);
        }
    }
}
